"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as i } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.144 2C8.197 2 5 5.19 5 9.124a7.07 7.07 0 0 0 1.42 4.263L11 21.302q.039.078.087.149l.01.017.002-.001a1.285 1.285 0 0 0 2.022.078l.012.007.044-.078q.104-.134.17-.291l4.489-7.756a7.08 7.08 0 0 0 1.45-4.302C19.287 5.19 16.09 2 12.144 2",
        clipRule: "evenodd"
      }
    )
  }
), m = i(e);
export {
  m as LocationPinSolid,
  m as default
};
